import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {FormArray, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-base-edit-bpmn',
  templateUrl: './base-edit-bpmn.component.html',
  styleUrls: ['./base-edit-bpmn.component.scss']
})
export class BaseEditBpmnComponent implements OnInit {
  @Input() formGroupParent: FormGroup;
  @Input() formName: string;
  @Input() listInput: any;
  @Input() arrGroup: any;
  @Input() show: boolean;
  @Output() valueChange = new EventEmitter();
  @Output() getDataChange = new EventEmitter();

  testEmitter$ = new BehaviorSubject<any>(false);
  constructor() {

  }

  ngOnInit() {

  }

  //Checkbox
  onCheckChangeNew(event, name) {
    const formArray: FormArray = this.formGroupParent.get(name) as FormArray;
    if(event.target.checked){
      formArray.push(new FormControl(event.target.value));
    }
    /* unselected */
    else{
      // find the unselected element
      let i: number = 0;

      formArray.controls.forEach((ctrl: FormControl) => {
        if(ctrl.value == event.target.value) {
          formArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  // helpers for View
  isControlValid(controlName: string): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation, controlName): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.dirty || control.touched;
  }
}
